module.exports = __webpack_public_path__ + "img/google-play-badge.e643f839.svg";